const config = require("../config")
const url = config.base_dev_url + "v2/z_farm_work_record"

module.exports = {
    getSimpleList: {
        url: url + "/getSimpleList",
        type: "get",
    },
    generalPendingFarmWork: {
        url: url + "/generalPendingFarmWork",
        type: "get",
    },
    getDetail: {
        url: url + "/detail-list",
        type: "get",
    },
    acceptFarmWorkRecord: {
        url: url + "/acceptFarmWorkRecord",
        type: "post",
    },
    issueFarmWorkRecord: {
        url: url + "/issueFarmWorkRecord",
        type: "post",
    },
    updateFlowStatus: {
        url: url + "/updateFlowStatus",
        type: "post",
    },
    //添加执行图片
    addExecuteImg: {
        url: url + "/addExecuteImg",
        type: "post",
    },
    //按区县统计服务亩数
    statisticsAreaByDistrict: {
        url: url + "/statisticsAreaByDistrict",
        type: "get",
    },
    // 获取触发照片
    getTriggerImg: {
        url: config.base_dev_url + "farm-work-manual-trigger/getImagesByRecordId",
        type: "get",
    },
    //农事类型列表
    getFarmWorkTypeList: {
        url: config.base_dev_url + "z_farm_work_type/list",
        type: "get",
    },
    //需求大厅接单简单农事记录列表
    getOrderReceivingSimpleList:{
        url: url + "/getOrderReceivingSimpleList",
        type: "get",
    },
    //根据城市的坐标返回区县列表
    getDistrictListByCity:{
        url: config.base_dev_url + "city/districtListbyPoint",
        type: "get",
    },
    //农资关注农场
    followFarm: {
        url: config.base_dev_url + "z_agricultural_store_farm/follow",
        type: "post",
    },
    //农资取消关注农场
    unfollowFarm: {
        url: config.base_dev_url + "z_agricultural_store_farm/unfollow",
        type: "post",
    },
    //修改农事记录公开状态
    updatePublicStatus: {
        url: url + "/updatePublicStatus",
        type: "post",
    },
    ignoreFarmWorkRecord: {
        url: url + "/ignoreFarmWorkRecord",
        type: "get",
    },
    addExecuteImgAndComplete: {
        url: url + "/addExecuteImgAndComplete",
        type: "post",
    },
    // 更新农事记录的预计执行日期
    updateExpectedExecuteDate: {
        url: url + "/updateExpectedExecuteDate",
        type: "get",
    },
    // resultReport
    resultReport: {
        url: url + "/resultReport",
        type: "get",
    },
    // 农事详情
    getDetailById: {
        url: url + "/detail",
        type: "get",
    },
}
